import { cn } from "@perceptron/utils/cn";
import useAnnotationMask from "../hooks/useAnnotationMask";
import { Annotation } from "../../types";

interface AnnotationsMaskProps {
  imageUrl: string | undefined;
  highlightedAnnotationIds: string[] | undefined;
  clickedAnnotationId: string | undefined;
  allFlattenedAnnotations: Annotation[];
  visibleAnnotationIds: Set<string>;
}

const AnnotationsMask = ({
  imageUrl,
  highlightedAnnotationIds,
  clickedAnnotationId,
  allFlattenedAnnotations,
  visibleAnnotationIds,
}: AnnotationsMaskProps) => {
  const annotationMask = useAnnotationMask({
    imageUrl,
    highlightedAnnotationIds,
    clickedAnnotationId,
    allFlattenedAnnotations,
    visibleAnnotationIds,
  });

  return (
    <div
      className={cn(
        "pointer-events-none absolute bottom-0 left-0 right-0 top-0 z-50 bg-black/50 transition-opacity duration-300",
        {
          "opacity-0": !annotationMask,
          "opacity-80": !!annotationMask,
        },
      )}
      style={{
        WebkitMaskImage: annotationMask,
        maskImage: annotationMask,
        WebkitMaskSize: "100% 100%",
        maskSize: "100% 100%",
      }}
    />
  );
};

export default AnnotationsMask;
